












import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import Element from './Element.vue';

@Component({
  components: {
    Element,
  },
  computed: { ...mapGetters(['selectedElement', 'elementsWithUnlockable']) },
})
export default class Elements extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Elements.vue